import React, { FC, useEffect } from 'react'
import s from './Products.module.scss'
import TopBanner from '../../components/TopBanner/TopBanner'
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs'
import { NavLink } from 'react-router-dom'
import CardProduct from '../../components/CardProduct/CardProduct'
import { useAppDispatch, useAppSelector } from '../../store/hooks'
import { scrollToTop } from '../../utils'
import { fetchByProducts } from '../../store/slices/productsSlice'
import Loader from '../../components/Loader/Loader'
import { Helmet } from 'react-helmet-async'

const Products: FC = () => {
    const { products, loading } = useAppSelector(state => state.products)
    const dispatch = useAppDispatch()

    useEffect(() => {
        scrollToTop()
        dispatch(fetchByProducts())
    }, [dispatch])

    return (
        <>
           <Helmet>
                <title>
                    Продукция | Phoenix Programs
                </title>

                <meta
                    name="description"
                    content="Продукция Phoenix Programs для автоматизации технологических процессов, программирования ПЛК и внедрения SCADA-систем. Надёжные инженерные решения для промышленности."
                />

                <link rel="canonical" href="https://phoenix-programs.ru/products" />

                {/* Open Graph */}
                <meta property="og:type" content="website" />
                <meta property="og:locale" content="ru_RU" />
                <meta property="og:url" content="https://phoenix-programs.ru/products" />
                <meta
                    property="og:title"
                    content="Продукция Phoenix Programs"
                />
                <meta
                    property="og:description"
                    content="Решения и продукция для автоматизации, ПЛК и SCADA."
                />
                <meta
                    property="og:image"
                    content="https://phoenix-programs.ru/logo192.png"
                />

                {/* Twitter */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta
                    name="twitter:title"
                    content="Продукция Phoenix Programs"
                />
                <meta
                    name="twitter:description"
                    content="Инженерные решения и продукция для промышленной автоматизации."
                />
                <meta
                    name="twitter:image"
                    content="https://phoenix-programs.ru/logo192.png"
                />

                <meta name="robots" content="index, follow" />
            </Helmet>

            {loading && <Loader />}
            <TopBanner title='Продукция' />
            <Breadcrumbs>
                <NavLink className={({ isActive }) => isActive ? s.active : ''} to={'/'} >Главная</NavLink>
                /
                <NavLink className={({ isActive }) => isActive ? s.active : ''} to={'/products'} >Продукция</NavLink>
            </Breadcrumbs>
            <section className={s.section}>
                <div className={`${s.wrapper} container`}>
                    {
                        products?.map((el) => (
                            <CardProduct key={el.id} data={el} />
                        ))
                    }
                </div>
            </section>
        </>
    )
}

export default Products

